export default
{
	AGENT: 'agent',
	VISITOR: 'visitor'
};